"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RateThisModule = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var GSWrapperComponent_1 = require("../../../GSWrapperComponent");
var RateThis_1 = require("./RateThis");
function RateThisModule(props) {
    return (React.createElement(GSWrapperComponent_1.GSWrapperComponent, null,
        React.createElement(RateThis_1.RateThis, tslib_1.__assign({}, props))));
}
exports.RateThisModule = RateThisModule;
